document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll('.wp-block-cancan-contacts');

	blocks.forEach((block) => {
		const rows = block.querySelectorAll('.contact-row');

		rows.forEach((row) => {
			const details = row.querySelector('.contact-details');

			// Don't propogate click event on link click
			details.addEventListener('click', (e) => {
				e.stopPropagation();
			});

			['click', 'keydown'].forEach((eventType) => {
				details.addEventListener(eventType, (e) => {
					e.stopPropagation();
				});
			});

			const open = () => {
				// Close all other rows inside this block
				rows.forEach((otherRow) => {
					if (otherRow !== row) {
						const otherDetails =
							otherRow.querySelector('.contact-details');

						gsap.killTweensOf(otherDetails);

						gsap.to(otherDetails, {
							height: 0,
							duration: 0.3,
							ease: 'power2.inOut',
							overwrite: 'auto',
							onComplete: () => {
								gsap.set(otherDetails, {
									visibility: 'hidden',
								});
							},
						});

						otherRow.classList.remove('is-open');
						otherRow.setAttribute('aria-expanded', 'false');
					}
				});

				// Open this row
				gsap.killTweensOf(details);

				gsap.to(details, {
					height: 'auto',
					duration: 0.35,
					ease: 'power2.out',
					overwrite: 'auto',
					onStart: () => {
						gsap.set(details, { visibility: 'visible' });
					},
				});

				row.classList.add('is-open');
				row.setAttribute('aria-expanded', 'true');
			};

			const close = () => {
				gsap.killTweensOf(details);

				gsap.to(details, {
					height: 0,
					duration: 0.3,
					ease: 'power2.inOut',
					overwrite: 'auto',
					onComplete: () => {
						gsap.set(details, { visibility: 'hidden' });
					},
				});

				row.classList.remove('is-open');
				row.setAttribute('aria-expanded', 'false');
			};

			const toggle = () => {
				row.classList.contains('is-open') ? close() : open();
			};

			/* -------------------------
               Click
            -------------------------- */
			row.addEventListener('click', toggle);

			/* -------------------------
               Keyboard
            -------------------------- */
			row.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					toggle();
				}
			});
		});

		/* -------------------------
           Resize recalculation
        -------------------------- */
		window.addEventListener('resize', () => {
			rows.forEach((row) => {
				if (row.classList.contains('is-open')) {
					const details = row.querySelector('.contact-details');
					gsap.set(details, { height: 'auto' });
				}
			});
		});
	});
});
